import { Table } from 'legacy/lut/library/list'
import { JSX, useCallback, useMemo, useState } from 'react'

import { IPartnerDuplicate } from 'clickNgo/entities/partner/models'
import { RowState } from 'core-components/library/list/types'
import { Static } from 'core-components/types'
import { Crud } from 'core/types/Crud'

import { columns } from './configs'
import { IPartnerDuplicatesContentProps } from './models'
import { PartnerDuplicatesRow } from './partnerDuplicatesRow/PartnerDuplicatesRow'

export const PartnerDuplicatesContent = ({
  searchResult,
  contentActions,
  contentMessages,
  tableAdditionalColumns,
  sortDifference,
  styleClasses,
}: IPartnerDuplicatesContentProps) => {
  const [tabsOpeningState, setTabsOpeningState] = useState<{ [key: string]: boolean }>({
    'row-0': true,
  })

  const changeTabsOpeningState = useCallback((key: string, flag: boolean) => {
    setTabsOpeningState((state) => ({ ...state, [key]: flag }))
  }, [])

  const searchResultCrud = useMemo(
    () =>
      new Crud({
        fetcher: new Static(searchResult),
        keyField: 'partnerId',
      }),
    [searchResult]
  )

  const rowTpl = useMemo(
    () =>
      (
        item: IPartnerDuplicate,
        renderChildren: (
          item: IPartnerDuplicate,
          rowState: RowState,
          additional: IObjectAny
        ) => JSX.Element,
        rowState: RowState,
        rowAttrs: IObjectAny,
        additional: IObjectAny
      ) => {
        return (
          <PartnerDuplicatesRow
            contentActions={contentActions}
            rowAttrs={rowAttrs}
            searchResult={item}
            renderChildren={renderChildren}
            rowState={rowState}
            additional={additional}
            contentMessages={contentMessages}
            tableAdditionalColumns={tableAdditionalColumns}
            changeTabsOpeningState={changeTabsOpeningState}
            isOpened={tabsOpeningState[rowAttrs.key]}
            sortDifference={sortDifference}
            styleClasses={styleClasses}
          />
        )
      },
    [
      changeTabsOpeningState,
      contentActions,
      contentMessages,
      sortDifference,
      tableAdditionalColumns,
      tabsOpeningState,
      styleClasses,
    ]
  )

  return (
    <Table
      source={searchResultCrud}
      columns={columns}
      header
      pagination
      hasHierarchy
      hasTranslate
      rowTpl={rowTpl}
    />
  )
}
